import * as Sentry from '@sentry/browser';
import {
  GENERIC_ERROR,
  HTTP_STATUS_CODES,
  ROUTES,
} from '@showbie-socrative/socrative-utils';

import store from '../../store';

function getResponseBody(error: any) {
  if (error.response && error.response.data) {
    return error.response.data;
  }
  return GENERIC_ERROR;
}

export function ErrorHandler(error: any) {
  const statusCode = error.response ? error.response.status : 0;
  const responseData = getResponseBody(error);
  switch (statusCode) {
    case HTTP_STATUS_CODES.HTTP_401_UNAUTHORIZED: {
      const reduxState = store.getState();
      const isTeacher = reduxState.teachers.teacher.isTeacher;

      if (isTeacher) {
        window.location.href = ROUTES.TEACHER_LOGIN;
        return;
      }
      window.location.href = ROUTES.STUDENT_LOGIN;
      return;
    }
    case HTTP_STATUS_CODES.HTTP_500_INTERNAL_SERVER_ERROR: //TODO-FUTURE: Explicit error handling for 500s (maybe have a popup)
    case HTTP_STATUS_CODES.HTTP_400_BAD_REQUEST:
    case HTTP_STATUS_CODES.HTTP_404_NOT_FOUND:
      Sentry.captureException(error);
      return responseData;
    default:
      Sentry.captureException(error);
      return GENERIC_ERROR;
  }
}
